import type { ChartDataPoint } from "../types";

/**
 * Safely extracts a numeric value from a chart data point payload.
 * When dataKey is provided, reads that specific property.
 * Otherwise, auto-detects the first numeric property (heartRate, systolic, diastolic).
 */
export const extractValue = (
  payload: ChartDataPoint,
  dataKey?: string
): number | null => {
  if (!payload || typeof payload !== "object") {
    return null;
  }

  if (dataKey) {
    const value = payload[dataKey as keyof ChartDataPoint];
    return typeof value === "number" ? value : null;
  }

  if (typeof payload.heartRate === "number") {
    return payload.heartRate;
  }
  if (typeof payload.systolic === "number") {
    return payload.systolic;
  }
  if (typeof payload.diastolic === "number") {
    return payload.diastolic;
  }

  return null;
};
